module.exports = __webpack_public_path__ + "static/media/logo-light.0fb691b2.svg";